/**
 * Social IM inbox helpers.
 * CUSTOMER_SERVICE（含未來揪團／業務綁定客服）與社交 IM 隔離，不得進一般會話列表。
 */

export function isCustomerServiceConversation(convOrType) {
  const type =
    typeof convOrType === 'string'
      ? convOrType
      : convOrType?.conversationType;
  return type === 'CUSTOMER_SERVICE';
}

export function filterSocialImConversations(list) {
  return (Array.isArray(list) ? list : []).filter((c) => !isCustomerServiceConversation(c));
}
